var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09863 16C5.30623 16.0001 5.48392 16.1286 5.63965 16.3994C5.72128 16.5706 6.07096 17.3841 6.69434 18.8467V16.0283H7.6582C7.87342 16.0283 7.98555 16.1431 8.00781 16.3643V21.4082L8 21.4004C8.03711 21.7571 7.82906 21.9568 7.38379 21.9854H6.99805C6.73832 22.0353 6.50056 21.8284 6.27051 21.3789C6.19584 21.2207 5.85478 20.3642 5.22461 18.7891V21.9502H4.32617C4.11867 21.9714 4.00747 21.8644 4 21.6221V16.3135C4.00021 16.1212 4.14116 16.0143 4.42285 16C4.48222 16.0143 4.71273 16.0143 5.09863 16ZM12 14L6.0127 11.0117L0 14L6.0127 0L12 14Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorth);
export default __webpack_public_path__ + "static/media/north.bc3e724ca3c25eef4580871a3042d7a3.svg";
export { ForwardRef as ReactComponent };